/**
 * Shared: Modules > Artistapplication
 *
 * @copyright 2024 i-fabrik GmbH
 * @author Tobias Garz
 */

import {extend} from '../../../shared/utils/index';
import {
	isElement,
	isString
}               from '../../../shared/utils/is';

import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator from "../../../shared/dom/manipulator";
import Data from '../../../shared/dom/data';
import Slider from '../../../shared/components/slider/slider';

// -------
// Private
// -------

const NAME      = 'artist-group';
const DATA_KEY  = `ifab.${NAME}`;
// const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY   = `.data-api`;

const ajaxUri = $("#applikation").data('ajax');

// -------
// Public
// -------

const renderForm = (id) => {
	const tpl      = SelectorEngine.findOne('#artist-form-dummy');
	const formList = SelectorEngine.findOne('#artist-forms');

	if(!tpl && !formList) {
		console.log('no copy template found!');

		return;
	}

	let formTpl = tpl.outerHTML;
	formTpl = formTpl.replace(/dummy/g, id);

	const form = Manipulator.createElementFrom(formTpl);

	Manipulator.elementPrepend(form, formList);

	serializeForm();
};

const renderCard = (id) => {
	const deck = SelectorEngine.findOne('.artists-group .deck__container');
	const tpl = Manipulator.createElementFrom(`<div class="card artist-card" id="artist-${id}">` +
		`<header class="card__header">` +
		`<div class="controls d-flex gap-3">` +
		`<button class="button -secondary -circle -s artist-edit" data-artist-form data-fancybox data-src="#artist-form-${id}" type="button">` +
		`<span class="button__label"><i class="fa-regular fa-pen-to-square"></i></span>` +
		`</button>` +
		`<button class="button -danger -circle -s artist-remove" data-remove="${id}" type="button">` +
		`<span class="button__label"><i class="fa-regular fa-trash"></i></span>` +
		`</button>` +
		`</div>` +
		`</header>` +
		`<div class="card__body">` +
		`<h3 class="artist-title">new Artist</h3>` +
		`</div>` +
		`</div>`);

	if(!deck) {
		return;
	}

	Manipulator.elementPrepend(tpl, deck);

	_addFancyboxHandlers(`[data-artist-form][data-src="#artist-form-${id}"]`);
};

const removeArtist = (id) => {
	const $card = $(`#artist-${id}`);
	const $form = $(`#artist-form-${id}`);

	if($card.length && $form.length) {
		$card.remove();
		$form.remove();
	}
};

const serializeForm = () => {
	setTimeout(function() {
		const time = Date.now();

		$.ajax({
			url    : ajaxUri,
			cache  : false,
			method : 'POST',
			data   :  $("#applikation").serialize(),
			success: function(data) {},
			error  : function(data) {}
		});
	}, 500);
};

const _addEventHandlers = () => {
	$(document).on('click', '.artist-card .artist-remove', function(event) {
		const id = $(this).attr('data-remove');

		removeArtist(id);
		serializeForm();
	});

	$(document).on('click', '#artist-add', function(event) {
		let rnd = Math.floor(Math.random() * (9999 - 10 + 1) + 10);

		while($(`#artist-form-${rnd}`).length) {
			let rnd = Math.floor(Math.random() * (9999 - 10 + 1) + 10);
		}

		renderForm(rnd);
		renderCard(rnd);
	});
};

const _addFancyboxHandlers = (selector) => {
	Fancybox.bind(selector, {
		groupAttr: false,
		idle : false,
		Toolbar  : {
			enabled: true,
			display: {
				right : ["close"]
			}
		},
		on : {
			close: (instance, el) => {
				// const $firstname = $('[id^="firstname"]', el.contentEl);
				// const $lastname = $('[id^="lastname"]', el.contentEl);
				// const $artistname = $('[id^="artistname"]', el.contentEl);
				//
				// console.log($firstname);
				// console.log($lastname);
				// console.log($artistname);

				serializeForm();
			},
			done : (instance, el) => {
				$('.artist-save', el.contentEl).on('click', function() {
					instance.close();
				});
			}
		}
	});
};

const _addOldEventsHandlers = () => {
	$(document).ready(function() {
		$(`[data-artist-form]`).each(function() {
			_addFancyboxHandlers('[data-src="' + $(this).attr('data-src') + '"]');
		});

		$(document).on("keydown", ":input:not(textarea)", function(event) {
			if (event.key == "Enter") {
				event.preventDefault();
			}
		});
	});

	$(document).on('change', '#applikation .form-control', function(wto) {
		serializeForm();
	});

	// $(document).on('keydown', '#applikation .form-control', function(wto) {
	// 	serializeForm();
	// });
};

document.addEventListener('DOMContentLoaded', function(event) {
	_addEventHandlers();
	_addOldEventsHandlers();
});